/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Box, Divider, Drawer, List } from '@mui/material';
import NavItem from './NavItem';
import { PassportAuth } from '../../contexts/AuthContext';

function MainSidebar({ onMobileClose, openMobile, items }) {
  const { handleSignout } = useContext(PassportAuth);

  const onSignOut = async () => {
    await handleSignout();
  };

  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem
              key={item.title}
              href={item.href}
              title={item.title}
              Icon={item.icon}
              sub={item.sub}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Divider />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2,
        }}
      >
        <Button
          size="small"
          startIcon={<i className="fas fa-fingerprint" />}
          variant="outlined"
          onClick={onSignOut}
        >
          ออกจากระบบ
        </Button>
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={openMobile}
      variant="temporary"
      PaperProps={{
        sx: {
          width: 256,
        },
      }}
    >
      {content}
    </Drawer>
  );
}

MainSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
};

export default MainSidebar;
